import { render } from "./StatsWidget.vue?vue&type=template&id=7bb9878b&scoped=true"
import script from "./StatsWidget.vue?vue&type=script&lang=js"
export * from "./StatsWidget.vue?vue&type=script&lang=js"

import "./StatsWidget.vue?vue&type=style&index=0&id=7bb9878b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb9878b"]])

export default __exports__